exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media screen and (max-width:1320px) {\n.v-btn[data-v-23ee1e48] {\n    padding: 0px 4px !important;\n}\n}\n.add-part[data-v-23ee1e48] {\n  width: 20px;\n  height: 20px;\n}\n.delete-part[data-v-23ee1e48] {\n  width: 20px;\n  height: 20px;\n}\n.v-card__title[data-v-23ee1e48] {\n  font-size: 1rem;\n}\n", ""]);

// exports
